import type { CrmMessages } from "./englishCrmMessages";
import {
  vietnameseJobMessages,
  vietnameseNavMessages,
} from "../../jobs/vietnameseJobMessages";

// Vietnamese has no grammatical plural: both sides of "||||" are identical.
export const vietnameseCrmMessages = {
  resources: {
    jobs: vietnameseJobMessages,
    companies: {
      name: "Doanh nghiệp |||| Doanh nghiệp",
      forcedCaseName: "Doanh nghiệp",
      fields: {
        name: "Tên doanh nghiệp",
        website: "Website",
        linkedin_url: "LinkedIn",
        phone_number: "Số điện thoại",
        created_at: "Ngày tạo",
        nb_contacts: "Số khách hàng",
        revenue: "Doanh thu",
        sector: "Lĩnh vực",
        size: "Quy mô",
        tax_identifier: "Mã số thuế",
        address: "Địa chỉ",
        city: "Tỉnh/Thành phố",
        zipcode: "Mã bưu chính",
        state_abbr: "Quận/Huyện",
        country: "Quốc gia",
        description: "Mô tả",
        context_links: "Liên kết tham khảo",
        sales_id: "Nhân viên phụ trách",
      },
      empty: {
        description: "Danh sách doanh nghiệp đang trống.",
        title: "Chưa có doanh nghiệp nào",
      },
      import: {
        title: "Nhập danh sách doanh nghiệp",
      },
      field_categories: {
        contact: "Liên hệ",
        additional_info: "Thông tin thêm",
        address: "Địa chỉ",
        context: "Bối cảnh",
      },
      action: {
        create: "Tạo doanh nghiệp",
        edit: "Sửa doanh nghiệp",
        new: "Doanh nghiệp mới",
        show: "Xem doanh nghiệp",
      },
      added_on: "Thêm ngày %{date}",
      followed_by: "Phụ trách: %{name}",
      followed_by_you: "Bạn phụ trách",
      no_contacts: "Chưa có khách hàng",
      nb_contacts: "%{smart_count} khách hàng |||| %{smart_count} khách hàng",
      nb_deals: "%{smart_count} công trình |||| %{smart_count} công trình",
      sizes: {
        one_employee: "1 nhân sự",
        two_to_nine_employees: "2-9 nhân sự",
        ten_to_forty_nine_employees: "10-49 nhân sự",
        fifty_to_two_hundred_forty_nine_employees: "50-249 nhân sự",
        two_hundred_fifty_or_more_employees: "Từ 250 nhân sự",
      },
      autocomplete: {
        create_error: "Có lỗi khi tạo doanh nghiệp",
        create_item: "Tạo %{item}",
        create_label: "Gõ tên để tạo doanh nghiệp mới",
      },
    },
    contacts: {
      name: "Khách hàng |||| Khách hàng",
      forcedCaseName: "Khách hàng",
      field_categories: {
        background_info: "Thông tin nền",
        identity: "Thông tin cá nhân",
        misc: "Khác",
        personal_info: "Liên hệ",
        position: "Chức vụ",
      },
      fields: {
        first_name: "Tên",
        last_name: "Họ và tên đệm",
        last_seen: "Liên hệ gần nhất",
        title: "Chức vụ",
        company_id: "Doanh nghiệp",
        email_jsonb: "Email",
        email: "Email",
        phone_jsonb: "Số điện thoại",
        phone_number: "Số điện thoại",
        linkedin_url: "LinkedIn",
        background:
          "Ghi chú về khách (nguồn khách, nhu cầu, địa chỉ công trình...)",
        has_newsletter: "Nhận tin khuyến mãi",
        sales_id: "Nhân viên phụ trách",
      },
      action: {
        add: "Thêm khách hàng",
        add_first: "Thêm khách hàng đầu tiên",
        create: "Tạo khách hàng",
        edit: "Sửa khách hàng",
        export_vcard: "Xuất vCard",
        new: "Khách hàng mới",
        show: "Xem khách hàng",
      },
      autocomplete: {
        create_item: "Tạo %{item}",
        create_label: "Gõ tên để tạo khách hàng mới",
      },
      background: {
        last_activity_on: "Hoạt động gần nhất %{date}",
        added_on: "Thêm ngày %{date}",
        followed_by: "Phụ trách: %{name}",
        followed_by_you: "Bạn phụ trách",
        status_none: "Chưa có",
      },
      position_at: "%{title} tại",
      position_at_company: "%{title} tại %{company}",
      empty: {
        description: "Danh sách khách hàng đang trống.",
        title: "Chưa có khách hàng nào",
      },
      import: {
        title: "Nhập danh sách khách hàng",
      },
      inputs: {
        genders: {
          male: "Anh",
          female: "Chị",
          nonbinary: "Khác",
        },
        personal_info_types: {
          work: "Công việc",
          home: "Nhà riêng",
          other: "Khác",
        },
      },
      list: {
        error_loading: "Lỗi khi tải danh sách khách hàng",
      },
      show: {
        error_loading: "Lỗi khi tải khách hàng",
      },
      bulk_tag: {
        action: "Gắn nhãn",
        back: "Quay lại danh sách nhãn",
        create_description: "Tạo nhãn mới và gắn cho các khách hàng đã chọn.",
        description:
          "Chọn nhãn có sẵn hoặc tạo nhãn mới cho các khách hàng đã chọn.",
        empty: "Chưa có nhãn nào. Hãy tạo nhãn để gắn cho khách hàng.",
        error: "Không gắn được nhãn cho khách hàng",
        removed:
          "Đã gỡ nhãn khỏi %{smart_count} khách hàng |||| Đã gỡ nhãn khỏi %{smart_count} khách hàng",
        success:
          "Đã gắn nhãn cho %{smart_count} khách hàng |||| Đã gắn nhãn cho %{smart_count} khách hàng",
        title: "Gắn nhãn cho khách hàng",
      },
      merge: {
        action: "Gộp với khách hàng khác",
        confirm: "Gộp khách hàng",
        current_contact: "Khách hàng hiện tại (sẽ bị xóa)",
        description: "Gộp khách hàng này với một khách hàng khác.",
        error: "Không gộp được khách hàng",
        merging: "Đang gộp...",
        no_additional_data: "Không có dữ liệu nào cần gộp thêm",
        select_target: "Hãy chọn khách hàng để gộp vào",
        success: "Đã gộp khách hàng",
        target_contact: "Khách hàng giữ lại",
        title: "Gộp khách hàng",
        warning_description:
          "Toàn bộ dữ liệu sẽ chuyển sang khách hàng thứ hai. Không thể hoàn tác.",
        warning_title: "Cảnh báo: thao tác không thể hoàn tác",
        what_will_be_merged: "Dữ liệu sẽ được gộp:",
      },
      filters: {
        before_last_month: "Trước tháng trước",
        before_this_month: "Trước tháng này",
        before_this_week: "Trước tuần này",
        managed_by_me: "Tôi phụ trách",
        search: "Tìm tên, doanh nghiệp...",
        this_week: "Tuần này",
        today: "Hôm nay",
        tags: "Nhãn",
        tasks: "Công việc",
      },
      hot: {
        empty_change_status:
          'Đổi trạng thái khách hàng bằng cách thêm ghi chú cho khách rồi bấm "Hiện tùy chọn".',
        empty_hint: 'Khách hàng có trạng thái "nóng" sẽ hiện ở đây.',
        title: "Khách hàng nóng",
      },
    },
    deals: {
      name: "Công trình |||| Công trình",
      fields: {
        name: "Tên công trình",
        description: "Mô tả",
        company_id: "Doanh nghiệp",
        contact_ids: "Khách hàng",
        categories: "Loại sản phẩm",
        amount: "Giá trị",
        expected_closing_date: "Ngày dự kiến",
        stage: "Trạng thái",
      },
      action: {
        back_to_deal: "Quay lại công trình",
        create: "Tạo công trình",
        new: "Công trình mới",
      },
      field_categories: {
        misc: "Khác",
      },
      filters: {
        only_mine: "Chỉ công trình tôi phụ trách",
      },
      archived: {
        action: "Lưu trữ",
        error: "Lỗi: chưa lưu trữ được công trình",
        list_title: "Công trình đã lưu trữ",
        success: "Đã lưu trữ công trình",
        title: "Công trình đã lưu trữ",
        view: "Xem công trình đã lưu trữ",
      },
      inputs: {
        linked_to: "Liên quan đến",
      },
      unarchived: {
        action: "Đưa lại lên bảng",
        error: "Lỗi: chưa bỏ lưu trữ được công trình",
        success: "Đã bỏ lưu trữ công trình",
      },
      updated: "Đã cập nhật công trình",
      empty: {
        before_create: "trước khi tạo công trình.",
        description: "Danh sách công trình đang trống.",
        title: "Chưa có công trình nào",
      },
      import: {
        title: "Nhập danh sách công trình",
      },
      invalid_date: "Ngày không hợp lệ",
    },
    notes: {
      name: "Ghi chú |||| Ghi chú",
      forcedCaseName: "Ghi chú",
      fields: {
        status: "Trạng thái",
        date: "Ngày",
        attachments: "Tệp đính kèm",
        contact_id: "Khách hàng",
        deal_id: "Công trình",
      },
      action: {
        add: "Thêm ghi chú",
        add_first: "Thêm ghi chú đầu tiên",
        delete: "Xóa ghi chú",
        edit: "Sửa ghi chú",
        update: "Cập nhật ghi chú",
        add_this: "Thêm ghi chú này",
      },
      sheet: {
        create: "Tạo ghi chú",
        create_for: "Tạo ghi chú cho %{name}",
        edit: "Sửa ghi chú",
        edit_for: "Sửa ghi chú của %{name}",
      },
      deleted: "Đã xóa ghi chú",
      empty: "Chưa có ghi chú",
      author_added: "%{name} đã thêm ghi chú",
      you_added: "Bạn đã thêm ghi chú",
      me: "Tôi",
      list: {
        error_loading: "Lỗi khi tải ghi chú",
      },
      note_for_contact: "Ghi chú cho %{name}",
      stepper: {
        hint: "Mở trang một khách hàng và thêm ghi chú",
      },
      added: "Đã thêm ghi chú",
      inputs: {
        add_note: "Thêm ghi chú",
        options_hint: "(đính kèm tệp, hoặc đổi chi tiết)",
        show_options: "Hiện tùy chọn",
      },
      actions: {
        attach_document: "Đính kèm tệp",
      },
      validation: {
        note_or_attachment_required: "Cần nhập ghi chú hoặc đính kèm tệp",
      },
    },
    sales: {
      name: "Nhân viên |||| Nhân viên",
      fields: {
        first_name: "Tên",
        last_name: "Họ và tên đệm",
        email: "Gmail đăng nhập",
        secondary_email: "Email phụ",
        secondary_emails: "Email phụ",
        administrator: "Quản trị",
        disabled: "Đã khóa",
      },
      create: {
        error: "Có lỗi khi tạo nhân viên.",
        success:
          "Đã tạo nhân viên. Nhân viên đăng nhập bằng nút Google với đúng địa chỉ Gmail này.",
        title: "Thêm nhân viên mới",
      },
      edit: {
        error: "Có lỗi xảy ra. Vui lòng thử lại.",
        record_not_found: "Không tìm thấy dữ liệu",
        success: "Đã cập nhật nhân viên",
        title: "Sửa %{name}",
      },
      action: {
        new: "Thêm nhân viên",
      },
    },
    tasks: {
      name: "Công việc |||| Công việc",
      forcedCaseName: "Công việc",
      fields: {
        text: "Nội dung",
        due_date: "Hạn",
        type: "Loại",
        contact_id: "Khách hàng",
        due_short: "hạn",
      },
      action: {
        add: "Thêm công việc",
        create: "Tạo công việc",
        edit: "Sửa công việc",
      },
      actions: {
        postpone_next_week: "Dời sang tuần sau",
        postpone_tomorrow: "Dời sang ngày mai",
        title: "thao tác công việc",
      },
      added: "Đã thêm công việc",
      deleted: "Đã xóa công việc",
      dialog: {
        create: "Tạo công việc",
        create_for: "Tạo công việc cho %{name}",
      },
      sheet: {
        edit: "Sửa công việc",
        edit_for: "Sửa công việc của %{name}",
      },
      empty: "Chưa có công việc",
      empty_list_hint: "Công việc gắn với khách hàng sẽ hiện ở đây.",
      filters: {
        later: "Sau này",
        overdue: "Quá hạn",
        this_week: "Tuần này",
        today: "Hôm nay",
        tomorrow: "Ngày mai",
        with_pending: "Còn việc chưa xong",
      },
      regarding_contact: "(Khách: %{name})",
      updated: "Đã cập nhật công việc",
    },
    tags: {
      name: "Nhãn |||| Nhãn",
      action: {
        add: "Thêm nhãn",
        create: "Tạo nhãn mới",
      },
      dialog: {
        color: "Màu",
        create_title: "Tạo nhãn mới",
        edit_title: "Sửa nhãn",
        name_label: "Tên nhãn",
        name_placeholder: "Nhập tên nhãn",
      },
      empty: "Chưa có nhãn.",
    },
  },
  crm: {
    nav: vietnameseNavMessages,
    action: {
      reset_password: "Đặt lại mật khẩu",
    },
    auth: {
      first_name: "Tên",
      last_name: "Họ và tên đệm",
      confirm_password: "Nhập lại mật khẩu",
      confirmation_required:
        "Vui lòng bấm vào đường dẫn chúng tôi vừa gửi qua email để xác nhận tài khoản.",
      recovery_email_sent:
        "Nếu bạn đã có tài khoản, bạn sẽ sớm nhận được email khôi phục mật khẩu.",
      sign_in_failed: "Đăng nhập không thành công.",
      sign_in_google: "Đăng nhập bằng Google",
      sign_in_google_workspace: "Đăng nhập bằng Google Workspace",
      signup: {
        create_account: "Tạo tài khoản",
        create_first_user:
          "Tạo tài khoản quản trị đầu tiên để hoàn tất cài đặt.",
        creating: "Đang tạo...",
        initial_user_created: "Đã tạo tài khoản đầu tiên",
      },
      welcome_title: "Chào mừng đến với hệ thống quản lý",
    },
    common: {
      account_manager: "Nhân viên phụ trách",
      activity: "Hoạt động",
      added: "đã thêm",
      details: "Chi tiết",
      last_activity_with_date: "hoạt động gần nhất %{date}",
      load_more: "Tải thêm",
      misc: "Khác",
      past: "Đã qua",
      read_more: "Xem thêm",
      retry: "Thử lại",
      show_less: "Thu gọn",
      copied: "Đã sao chép!",
      copy: "Sao chép",
      loading: "Đang tải...",
      me: "Tôi",
      task_count: "%{smart_count} công việc |||| %{smart_count} công việc",
    },
    changelog: {
      title: "Nhật ký thay đổi",
    },
    activity: {
      added_company: "%{name} đã thêm doanh nghiệp",
      you_added_company: "Bạn đã thêm doanh nghiệp",
      added_contact: "%{name} đã thêm",
      you_added_contact: "Bạn đã thêm",
      added_note: "%{name} đã ghi chú về",
      you_added_note: "Bạn đã ghi chú về",
      added_note_about_deal: "%{name} đã ghi chú về công trình",
      you_added_note_about_deal: "Bạn đã ghi chú về công trình",
      added_deal: "%{name} đã thêm công trình",
      you_added_deal: "Bạn đã thêm công trình",
      at_company: "tại",
      to: "vào",
      load_more: "Tải thêm hoạt động",
    },
    dashboard: {
      deals_chart: "Doanh thu công trình sắp tới",
      deals_pipeline: "Công trình đang chạy",
      latest_activity: "Hoạt động gần đây",
      latest_activity_error: "Lỗi khi tải hoạt động gần đây",
      latest_notes: "Ghi chú gần đây của tôi",
      latest_notes_added_ago: "thêm %{timeAgo}",
      stepper: {
        install: "Cài đặt hệ thống",
        progress: "Đã xong %{step}/3",
        whats_next: "Bước tiếp theo?",
      },
      upcoming_tasks: "Công việc sắp tới",
    },
    data_import: {
      button: "Nhập CSV",
      complete: "Đã nhập xong %{importCount} dòng, có %{errorCount} lỗi",
      csv_file: "Tệp CSV",
      error: "Không nhập được tệp này, hãy kiểm tra đúng định dạng CSV.",
      in_progress: "Đang nhập…",
      progress:
        "Đã nhập %{importCount} / %{rowCount} dòng, có %{errorCount} lỗi.",
      remaining_time: "Thời gian còn lại ước tính:",
      resource: "Loại dữ liệu",
      sample_download: "Tải tệp CSV mẫu",
      sample_hint: "Tệp CSV mẫu để làm theo",
      start: "Bắt đầu nhập",
      stop: "Dừng nhập",
      stopped: "Đã dừng. Đã nhập %{importCount} dòng, có %{errorCount} lỗi",
      title: "Nhập dữ liệu",
    },
    header: {
      import_data: "Nhập từ JSON",
    },
    search: {
      title: "Tìm kiếm",
      placeholder:
        "Tìm khách hàng, doanh nghiệp, công trình, công việc, ghi chú...",
      hint: "Gõ ít nhất %{min} ký tự để tìm",
      empty: "Không tìm thấy kết quả",
      error: "Tạm thời không tìm kiếm được. Vui lòng thử lại.",
      untitled_result: "(không có tiêu đề)",
      show_more: "Xem thêm",
      groups: {
        contacts: "Khách hàng",
        companies: "Doanh nghiệp",
        deals: "Công trình",
        tasks: "Công việc",
        contact_notes: "Ghi chú khách hàng",
        deal_notes: "Ghi chú công trình",
      },
    },
    image_editor: {
      change: "Đổi",
      drop_hint: "Kéo thả tệp vào đây, hoặc bấm để chọn.",
      editable_content: "Nội dung chỉnh sửa được",
      title: "Tải lên và cắt ảnh",
      update_image: "Cập nhật ảnh",
    },
    import: {
      action: {
        download_error_report: "Tải báo cáo lỗi",
        import: "Nhập",
        import_another: "Nhập tệp khác",
      },
      error: {
        unable: "Không nhập được tệp này.",
      },
      idle: {
        description_1:
          "Có thể nhập nhân viên, doanh nghiệp, khách hàng, ghi chú và công việc.",
        description_2: "Dữ liệu phải là tệp JSON theo mẫu sau:",
      },
      status: {
        all_success: "Đã nhập thành công toàn bộ dữ liệu.",
        complete: "Đã nhập xong.",
        failed: "Lỗi",
        imported: "Đã nhập",
        in_progress: "Đang nhập, vui lòng không rời khỏi trang này.",
        some_failed: "Một số dòng chưa nhập được.",
        table_caption: "Trạng thái nhập",
      },
      title: "Nhập từ JSON",
    },
    settings: {
      about: "Giới thiệu",
      companies: {
        sectors: "Lĩnh vực",
      },
      dark_mode_logo: "Logo nền tối",
      deals: {
        categories: "Loại sản phẩm",
        currency: "Tiền tệ",
        pipeline_help:
          "Chọn các trạng thái công trình được tính vào doanh thu dự kiến.",
        pipeline_statuses: "Trạng thái tính doanh thu",
        stages: "Trạng thái công trình",
      },
      light_mode_logo: "Logo nền sáng",
      notes: {
        statuses: "Trạng thái",
      },
      reset_defaults: "Khôi phục mặc định",
      save_error: "Không lưu được cấu hình",
      saved: "Đã lưu cấu hình",
      saving: "Đang lưu...",
      tasks: {
        types: "Loại công việc",
      },
      preferences: "Tùy chọn",
      title: "Cài đặt",
      app_title: "Tên ứng dụng",
      sections: {
        branding: "Thương hiệu",
      },
      validation: {
        duplicate: "Trùng %{display_name}: %{items}",
        in_use:
          "Không xóa được %{display_name} đang được công trình sử dụng: %{items}",
        validating: "Đang kiểm tra…",
        entities: {
          categories: "loại sản phẩm",
          stages: "trạng thái",
        },
      },
    },
    theme: {
      dark: "Tối",
      label: "Giao diện",
      light: "Sáng",
      system: "Theo hệ thống",
    },
    language: "Ngôn ngữ",
    navigation: {
      label: "Điều hướng",
    },
    profile: {
      add_secondary_email: "Thêm email",
      email_taken: "%{email} đã được nhân viên khác sử dụng",
      no_secondary_emails: "Chưa có",
      secondary_email_invalid: "%{email} không phải email hợp lệ",
      secondary_email_is_primary: "%{email} đã là email chính của bạn",
      secondary_email_taken: "%{email} đã được nhân viên khác sử dụng",
      too_many_secondary_emails: "Không thể thêm quá 10 email phụ",
      secondary_emails_help:
        "Các địa chỉ khác bạn dùng để gửi email. Để trống một ô để xóa.",
      inbound: {
        description:
          "Bạn có thể gửi email tới địa chỉ nhận thư của hệ thống, ví dụ thêm vào ô %{field}. Hệ thống sẽ xử lý và thêm ghi chú cho khách hàng tương ứng.",
        title: "Email đến",
      },
      mcp: {
        title: "Máy chủ MCP",
        description:
          "Dùng đường dẫn này để kết nối trợ lý AI với dữ liệu hệ thống qua Model Context Protocol (MCP).",
      },
      password: {
        change: "Đổi mật khẩu",
      },
      password_reset_sent: "Đã gửi email đặt lại mật khẩu tới địa chỉ của bạn",
      record_not_found: "Không tìm thấy dữ liệu",
      title: "Hồ sơ",
      updated: "Đã cập nhật hồ sơ",
      update_error: "Có lỗi xảy ra. Vui lòng thử lại",
    },
    validation: {
      invalid_url: "Đường dẫn không hợp lệ",
      invalid_linkedin_url: "Đường dẫn phải thuộc linkedin.com",
    },
  },
} satisfies CrmMessages;
